export default __webpack_public_path__ + "static/media/concrete-tar-icon.b1b946a1.svg";